import { render, staticRenderFns } from "./ProjecaoCard.vue?vue&type=template&id=7ce4180b&"
import script from "./ProjecaoCard.vue?vue&type=script&lang=js&"
export * from "./ProjecaoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports